document.addEventListener("DOMContentLoaded", function () {
  const form = document.forms["contact-form"];
  form.addEventListener("submit", postData);
});

function postData(event) {
  event.preventDefault();

  // Check if any alert exist => hide them
  let formAlert = document.querySelectorAll(".form__sent");
  if(formAlert) {
    formAlert.forEach((e) => {
      e.style.display = "none";
    });
  }

  const formElement = event.target;
  const xhr = new XMLHttpRequest();
  const form = new FormData(formElement);

  // Define what happens on successful data submission
  xhr.addEventListener("load", function (event) {
    if (event.target.status === 200) {
      let formSent = document.querySelector(".form__sent--success")
      formSent.style.display = "flex";
      formSent.setAttribute("aria-live", "polite");
      document.querySelector(".contact-us__container").style.display = "none";
      document.querySelector(".form__sent--success p").innerText = JSON.parse(
        event.target.responseText
      ).message;
    } else if (event.target.status >= 400 && event.target.status < 500) {
      let formSentError = document.querySelector(".form__sent--error")
      formSentError.style.display = "flex";
      formSentError.setAttribute("aria-live", "polite");
      document.querySelector(".form__sent--error p").innerText = JSON.parse(
        event.target.responseText
      ).message;
    } else {
      document.querySelector(".form__sent--network-error").style.display =
        "flex";
      document.querySelector(
        ".form__sent--network-error p"
      ).innerText = JSON.parse(event.target.responseText).message;
    }
  });

  // Define what happens in case of error
  xhr.addEventListener("error", function (event) {
    document.querySelector(".form__sent--network-error").style.display = "flex";
    document.querySelector(".form__sent--network-error p").innerText =
      "Při zpracovávání požadavku došlo k blíže nespecifikované chybě. Kontaktujte nás prosím na webstudio-iba@iba.muni.cz";
  });

  xhr.open("POST", "/admin/mail");
  xhr.send(form);
}

document.querySelectorAll(".form__close-button").forEach((e) => {
  e.addEventListener("click", (event) => {
    document.querySelectorAll(".form__sent").forEach((e) => {
      e.style.display = "none";
    });
  });
});
